export interface EfbFuelDetailsRecord {
  [key: string]: number | string | null | boolean;
  EFB_ID: number | null;
  OnBlockFuel: number | null;
  FuelUpliftLTR: number | null;
  FuelUpliftKG: number | null;
  OffBlockFuel: number | null;
  Density: number | null;
  CalculatedOnBlockFuel: number | null;
  OnBlockDiff: number | null;
  FuelType: string | null;
  ExtraFuel: number | null;
  Reason: string | null;
  ExtraFuelUseKG: number | null;
  ReasonExtraFuelUse: string | null;
  Subtype: string | null;
  Comment: string | null;
  AircraftRegistration: string | null;
  LegNumber: number | null;
  CarrierCode: string | null;
  FlightNumber: number | null;
  DepartureAerodrome: string | null;
  ArrivalAerodrome: string | null;
  AirportContractId: number | null;
  IsMixedDataReturn: boolean;
}
